import { useState } from "react";
import {
  Button,
  Box,
  Alert,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import Field from "./components/Field";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ContactUsForm = () => {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);
    formData.append("_captcha", "false");
    formData.append(
      "_subject",
      "Contact Us Form Submission via El Deeb UK website",
    );

    try {
      const response = await fetch("https://formsubmit.co/adham@eldeebco.uk", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setStatus("success");
        e.target.reset();
      } else {
        setStatus("error");
      }
    } catch (error) {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      {status === "success" && (
        <Alert severity="success">
          Thank you for reaching out! Your message has been received. Our team
          will get back to you as soon as possible.
        </Alert>
      )}
      {status === "error" && (
        <Alert severity="error">Something went wrong. Try again.</Alert>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Field title="Name" fieldName="name" type="input" />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field title="Phone number" fieldName="phone number" type="input" />
        </Grid>
        <Grid item xs={12}>
          <Field title="Email" fieldName="email" type="email" />
        </Grid>
        <Grid item xs={12}>
          <Field
            title="How can I help you"
            fieldName="inquery"
            type="input"
            multiline
            rows={4}
          />
        </Grid>
      </Grid>
      <Typography
        sx={{
          fontWeight: 300,
          fontSize: { xs: "10px", md: "12px" },
          fontFamily: "Montserrat",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          columnGap: 1,
          width: { md: "80%" },
        }}
      >
        <InfoOutlinedIcon
          sx={{
            fontSize: { xs: "20px", md: "20px" },
          }}
        />{" "}
        By submitting any enquiries you are granting El Deeb for Import, Export
        & TA Limited permission to store and process your data as according to
        our Privacy Policy. Your information will never be sold to any third
        parties, and the data you submit will only be used in relation to your
        enquiry.
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "auto" }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ borderRadius: "10px", pl: 7, pr: 7 }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Send"}
        </Button>
      </Box>
    </Box>
  );
};

export default ContactUsForm;
